module.exports = __webpack_public_path__ + "img/livebai.b3dd1718.png";